module.exports = __webpack_public_path__ + "static/media/image17.2841c845.png";